import React, { useEffect } from "react";
import { connect } from "react-redux";
import Cookies from "universal-cookie";
import { Bot } from "lucide-react";
import { fetchUser } from "../../actions/user.actions";

import { useAiChatPanel } from "../app/aiChatPanel";
import CompanyAccountSwitcher from "@/components/company/companyAccountSwitcher";
import UserProfileCompletionNavBarButton from "@/components/user/userProfileCompletion/userProfileCompletionNavBarButton";
import CollectionsContainer from "../../containers/navbar/collections.container";
import UserProfileMenuContainer from "../../containers/navbar/user-profile-menu.container";
import LanguagePickerDropdown from "../languagePickerDropdown";
import { Button } from "@/components/ui/button";

function AppNavBar({ companyId, fetchUser, showAiChat }) {
  useEffect(() => {
    const accessToken = new Cookies().get("accessToken");
    if (accessToken) {
      fetchUser("me");
    }
  }, [companyId, fetchUser]);

  const { isAiChatCollapsed, isUpdatingUser, setAiChatCollapsed } =
    useAiChatPanel();

  return (
    <header className="z-[26]">
      <div className="from-background px-sm grid h-[50px] grid-cols-[1fr_auto] items-center bg-gradient-to-b from-[60%] to-transparent">
        <div>
          <div className="gap-sm hidden items-center lg:flex">
            <CompanyAccountSwitcher />
          </div>
        </div>

        <ul className="flex">
          <li>
            <CollectionsContainer />
          </li>
          <li>
            <UserProfileCompletionNavBarButton />
          </li>
          <li>
            <UserProfileMenuContainer />
          </li>
          <li>
            <LanguagePickerDropdown className="cursor-pointer border-none bg-transparent py-[20px]" />
          </li>
          {showAiChat && isAiChatCollapsed && (
            <li>
              <Button
                variant="ghost"
                className="h-[40px] rounded-none"
                onClick={() => setAiChatCollapsed(false)}
                aria-label="Expand AI chat"
                isLoading={isUpdatingUser}
              >
                <Bot size={24} />
                Invono AI
              </Button>
            </li>
          )}
        </ul>
      </div>
    </header>
  );
}

function mapStateToProps(state) {
  return {
    companyId: state.company?.company?.id,
  };
}

const mapActionsToProps = {
  fetchUser,
};

export { AppNavBar };
export default connect(mapStateToProps, mapActionsToProps)(AppNavBar);
